import React, { Fragment, useState, useContext } from 'react';
import styles from './Guidance.module.scss';
import cx from 'classnames';
import { AlertCircle, XCircle } from 'react-feather';
import { AuthContext } from '../../services/user/AuthProvider';
import { useTranslation } from 'react-i18next';
import boomer from '../../images/loader-boomer.png'
import lightBulb from '../../images/light-bulb.png';

const Guidance = ({ text, title = 'Instructions', readingPage = false, reviewPage = false, headingImage = lightBulb }) => {

    const [guidanceMobile, setGuidanceMobile] = useState(false);
    const { t } = useTranslation();

    const formattedText = readingPage && typeof text === 'string' ? text.split('\n').map((line, index, lines) => (
        <Fragment key={`${line}-${index}`}>
            {line}
            {index < lines.length - 1 && <br />}
        </Fragment>
    )) : text;

    const toggleGuidanceInfo = () => {
        guidanceMobile ? setGuidanceMobile(false) : setGuidanceMobile(true);
    }

    const { currentUser: user } = useContext(AuthContext);
    
    const renderGuidance = () => {
        return (
            <Fragment>
                <h3 className={cx(styles.guidanceTitle, {
                    [styles.guidanceTitleReadingPage]: readingPage,
                    [styles.guidanceTitleReviewPage]: reviewPage
                })}>
                    {readingPage ? <img src={headingImage} alt="" /> : <AlertCircle size="30" />} {t(title)}
                </h3>
                <div className={cx(styles.guidanceContent, { [styles.guidanceContentReadingPage]: readingPage })}>{formattedText}</div>
            </Fragment>
        )
    }

    return(
        <div className={cx(styles.guidance, { [styles.guidanceReadingPage]: readingPage })}>
            {!readingPage && <img src={user.boomerAvatarUrl ? `${user.boomerAvatarUrl}?v=${user.updatedAt.replace(/\s/g, '' )}` : boomer} className={styles.guidanceAvatar} alt="" />}
            {!readingPage && <div onClick={toggleGuidanceInfo} className={styles.guidanceInfoIcon}><AlertCircle /></div>}
            <div className={cx(styles.guidancePanel, { [styles.guidancePanelReadingPage]: readingPage })}>
                {renderGuidance()}
            </div>
            {
                !readingPage && guidanceMobile && (
                    <div className={styles.guidanceMobile}>
                        <div className={styles.guidanceMobileInner}>
                            <div onClick={toggleGuidanceInfo} className={styles.guidanceMobileClose}><XCircle size="30" /></div>
                            <div className={styles.guidanceMobileAvatarHolder}>
                                <div className={styles.guidanceMobileAvatar}>
                                <img src={user.boomerAvatarUrl ? `${user.boomerAvatarUrl}?v=${user.updatedAt.replace(/\s/g, '' )}` : boomer} alt="" />
                                </div>
                            </div>
                            <div className={cx(styles.guidancePanel, styles.guidanceMobilePanel)}>
                                {renderGuidance()}
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Guidance;
